import React from 'react';
import PropTypes from 'prop-types';

const CreditCardInfo = (props) => {
  return (
    <div id="chargePayingWithCreditCard" className="wrapper">
      <h3 className="title" style={{textAlign: props.align}}>{props.intl.getMessage('creditcardinfo_paying_with')}</h3>
      <div className='paymentDetails' style={{justifyContent: props.align}}>
        <img 
          src={`/images/${props.cardType.toLowerCase()}.png`} 
          alt={props.cardType} 
          className={['twint'].includes(props.cardType) ?  "paymentImgLarge" : "paymentImgSmall"}/>
        {props.cardType !== 'twint' ? (<span className="cardNumber">XXXX XXXX XXXX {props.cardPartialPan}</span>) : (<span></span>)}
      </div>
    </div>
  );
};

CreditCardInfo.propTypes = {
  cardType: PropTypes.string.isRequired,
  cardPartialPan: PropTypes.string.isRequired,
  align: PropTypes.oneOf(['left', 'center']).isRequired
};

export default CreditCardInfo;
